// extracted by mini-css-extract-plugin
export var active = "_bs-2";
export var container = "_bs-0";
export var expired = "_bs-3";
export var hasStatus = "_bs-4";
export var statusChip = "_bs-1";